import UserVisitsTable from "./user-visits-table";

export default UserVisitsTable;